import moment from 'moment'
import { CURRENCY_COUNTRY_CODE, FIELD_TYPES, FORMATS } from '../../../utility/constants'
import { getFieldId, getFieldIdFromKey } from './utils'

export const getFilteredTableData = (tableData, filterValues, listDataMetadata, columns) => {
  let filterData = { ...tableData }
  for (const key in filterValues) {
    if (Object.hasOwnProperty.call(filterValues, key)) {
      const eleValue = filterValues[key]
      const field = columns.find((it) => it.id === getFieldIdFromKey(key).id)

      // here, we have actual value and fieldId - apply filter here
      filterData = Object.entries(filterData).reduce((acc, [key, value]) => {
        if (field.data_structure === FIELD_TYPES.LIST) {
          const listDataId = value[getFieldId(field.id)]
          const listData = listDataMetadata.find((it) => it.list_data_id == listDataId)
          if (listData?.list_data_value && containsKeys(listData?.list_data_value, eleValue)) {
            return { ...acc, [key]: value }
          } else {
            return { ...acc }
          }
        } else if (field.data_structure === FIELD_TYPES.LIST_MULTI) {
          const listDataIds = value[getFieldId(field.id)]
          const actualValue = listDataIds
            .map((id) => listDataMetadata.find((it) => it.list_data_id === id))
            .map((it) => it.list_data_value)
            .join(' ')

          if (actualValue && containsKeys(actualValue, eleValue)) {
            return { ...acc, [key]: value }
          } else {
            return { ...acc }
          }
        } else if (field.data_structure === FIELD_TYPES.TIMESTAMPED_BIGTEXT) {
          const v = value[getFieldId(field.id)]
          const actualValue = Array.isArray(v) ? v?.map((it) => it.text)?.join(' ') : ''

          if (containsKeys(actualValue, eleValue)) {
            return { ...acc, [key]: value }
          } else {
            return { ...acc }
          }
        } else if (
          field.data_structure === FIELD_TYPES.DATE ||
          field.data_structure === FIELD_TYPES.DATETIME
        ) {
          const actualValue = moment(value[getFieldId(field.id)]).format(
            field.data_structure === FIELD_TYPES.DATE ? FORMATS.DATE : FORMATS.DATETIME
          )

          if (containsKeys(actualValue, eleValue)) {
            return { ...acc, [key]: value }
          } else {
            return { ...acc }
          }
        } else {
          const actualValue = String(value[getFieldId(field.id)])
          if (containsKeys(actualValue, eleValue)) {
            return { ...acc, [key]: value }
          } else {
            return { ...acc }
          }
        }
      }, {})
    }
  }
  return filterData
}

export const containsKeys = (value, searchText, fieldType, cellCurrencyObject) => {
  if (!searchText) return true

  if (Array.isArray(searchText)) {
    if (fieldType === FIELD_TYPES.NUMBER) {
      const numValue = parseFloat(value)
      const [start, end] = searchText
      return (start === null || numValue >= start) && (end === null || numValue <= end)
    } else if (fieldType === FIELD_TYPES.DATE || fieldType === FIELD_TYPES.DATETIME) {
      const [start, end] = searchText
      const dateValue = new Date(value)

      // Adjust the end date to include the entire day
      const endDate = new Date(end)
      endDate.setHours(23, 59, 59, 999)

      return dateValue >= start && dateValue <= endDate
    } else if (fieldType === FIELD_TYPES.LIST || fieldType === FIELD_TYPES.LIST_MULTI) {
      return searchText?.includes(value)
    } else {
      return searchText?.includes(value)
    }
  } else if (fieldType === FIELD_TYPES.CURRENCY) {
    const { currency, range } = searchText
    const numValue = parseFloat(value.replace(/[^0-9.-]+/g, '').replace(/,/g, ''))
    const [start, end] = range

    // return  true for only if
    // Currency Of Cell is same as currency of Search Text, and
    // Cell Value falls in the range

    const cellCurrencyCode = cellCurrencyObject ? cellCurrencyObject.currency_code : 'INR'
    const cellCurrency = CURRENCY_COUNTRY_CODE[cellCurrencyCode] || '₹'
    if (!start && !end) {
      return true
    }
    return cellCurrency == currency && numValue >= start && numValue <= end
  } else if (fieldType === FIELD_TYPES.TIMESTAMPED_BIGTEXT) {
    const timestampedTexts = value
    const latestEntry = timestampedTexts.sort(
      (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
    )[0]
    const concatenatedText = latestEntry ? latestEntry.text : ''
    let searchTokens = searchText.trim().toLowerCase().split(' ')
    console.log('Search concatenatedText: ', concatenatedText)
    return searchTokens.every((st) => concatenatedText.toLowerCase().includes(st))
  } else {
    let searchTokens = searchText.trim().toLowerCase().split(' ')
    return searchTokens.every((st) => value.toString().toLowerCase().includes(st))
  }
}
